import { useGetPlotRiskAssessmentHistory } from '../../../hooks/usePlotRiskAssessments';
import RiskAssessmentHistory from '../../../shared/components/RiskAssessment/RiskAssessmentHistory';
type PlotRiskActivitiesTabProps = {
  assessmentId: string | undefined;
};

const PlotRiskActivitiesTab = ({
  assessmentId,
}: PlotRiskActivitiesTabProps) => {
  const { data: plotRiskHistory, isFetching } =
    useGetPlotRiskAssessmentHistory(assessmentId);

  return (
    <RiskAssessmentHistory riskHistory={plotRiskHistory} loading={isFetching} />
  );
};

export default PlotRiskActivitiesTab;
